import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";

// namespace SlotGames {
export class LuckyIce_2Screen extends SlotGameType1_2Screen {


    protected override helpFactory: IHelpFactory = new LuckyIceHelpFactory();
    //protected override panelFactory: IPanelFactory = new LuckyIcePanelFactory();

    //LED COLOR
    protected override ColorLed: string = "250,0,0\n";

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "LuckyIce");
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }

    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "#0A7CBF",
            coloroutherStroke: "black",
            colorinnerStroke: "#031333",
        }
}

//Help Colorized
class LuckyIceHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new LuckyIceHelp(params);
    }
}

class LuckyIceHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(6, 42, 115),rgb(8, 61, 166), rgb(7, 86, 242),rgb(8, 61, 166),rgb(6, 42, 115)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}

//Panel Colorized
class LuckyIcePanelFactory implements IPanelFactory {
    public CreateNewPanel(params: PanelParams): Panel {
        return new LuckyIcePanel(params);
    }
}

class LuckyIcePanel extends Panel {
    protected override ButtonBackground(): ButtonColors {
        let color: ButtonColors = {
            backgroundButtonColor: "linear-gradient(rgb(2, 77, 49),rgb(3, 115, 74), rgb(4, 140, 90),rgb(3, 115, 74),rgb(2, 77, 49)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
        };
        return color;

    }

}

// }
